import styled from "styled-components";

const DesktopFlightInfo = styled.div`
  display: block;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export default DesktopFlightInfo;
